var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ci-keyboard"},_vm._l((_vm.keyboard),function(key){return _c('div',{key:key,staticClass:"ci-keyboard__key",class:{
      'ci-keyboard__key--cancel': key === 'cancel',
    },on:{"click":function($event){return _vm.$emit('key', key)}}},[(key === 'del')?[_c('img',{staticClass:"ci-keyboard__img",attrs:{"src":require("@/assets/img/intercom/backwards@3x.webp"),"alt":""}})]:(key === 'cancel')?[_vm._v("\n      取消\n    ")]:[_vm._v("\n      "+_vm._s(key)+"\n    ")]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }